<template>
  <b-modal
    id="download-history"
    ref="download-history"
    size="md"
    modal-class="mc-modal-right"
    :title="$t('videoHistory.modalVideoDownload.title')"
    hide-footer
  >
    <div class="mc-modal__filter">
      <div class="mc-modal__filter-item">
        <b-form-group :label="$t('videoHistory.modalVideoDownload.channel')">
          <multiselect
            v-model="filterValue.channel"
            :placeholder="$t('videoHistory.modalVideoDownload.placeholder.selectCamera')"
            :options="channelOptions"
            label="label"
            trackBy="value"
          />
        </b-form-group>
      </div>
      <div class="mc-modal__filter-item">
        <b-form-group :label="$t('videoHistory.modalVideoDownload.date')">
          <FormulateInput
            v-model="filterValue.selectedDate"
            class="mt-2 px-0"
            :placeholder="$t('videoHistory.modalVideoDownload.date')"
            type="date-picker"
            format="DD MMM YYYY"
            datepickerType="date"
            valueType="YYYY-MM-DD"
            :confirmText="$t('global.action.apply')"
            :disabled-date="disabledDate"
          />
        </b-form-group>
      </div>
      <div class="mc-modal__filter-item">
        <b-form-group :label="$t('videoHistory.modalVideoDownload.videoTime')">
          <b-row>
            <b-col md="6">
              <date-picker
                v-model="filterValue.startTime"
                format="HH:mm"
                value-type="format"
                type="time"
                placeholder="HH:mm"
              />
            </b-col>
            <b-col md="6">
              <date-picker
                v-model="filterValue.endTime"
                format="HH:mm"
                value-type="format"
                type="time"
                placeholder="HH:mm"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </div>
      <div class="mc-modal__filter-item">
        <b-button variant="primary" class="d-block w-100" @click="handleClickDownload()">
          <i class="mc-fa icon-outline_download"></i>
          {{ $t('videoHistory.modalVideoDownload.download') }}
          <span
            v-if="$store.state.vehicle.isLoadingDownloadVideoHistoriesWidget"
            class="mx-2 spinner-border spinner-border-sm text-white"
          ></span>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import moment from 'moment'
moment.locale('id')

export default {
  name: 'FilterDownloadVideoHistory',
  components: {
    Multiselect,
  },
  mixins: [Helper, MixPanel],

  data() {
    return {
      filterValue: {
        channel: null,
        selectedDate: null,
        startTime: null,
        endTime: null,
      },
      jcOptions: [
        {
          value: 1,
          label: this.$t('trackVideo.camera') + ' 1',
        },
        {
          value: 2,
          label: this.$t('trackVideo.camera') + ' 2',
        },
      ],
      bsjOptions: [
        {
          value: 'CH01',
          label: this.$t('trackVideo.camera') + ' 1',
        },
        {
          value: 'CH02',
          label: this.$t('trackVideo.camera') + ' 2',
        },
        {
          value: 'CH03',
          label: this.$t('trackVideo.camera') + ' 3',
        },
        {
          value: 'CH04',
          label: this.$t('trackVideo.camera') + ' 4',
        },
      ],
    }
  },

  computed: {
    ...mapGetters('vehicle', ['vehicleDetail']),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    deviceType() {
      return this.$store.state.vehicle.vehicleDetail?.deviceName
    },
    channelOptions() {
      return this.deviceType === 'bsj' ? this.bsjOptions : this.jcOptions
    },
    isVideoDemo() {
      if (!this.$route.query?.vehicleId) return false
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.query?.vehicleId.toString())
    },
  },
  methods: {
    disabledDate(date) {
      return new Date(date) > new Date()
    },
    async handleDownloadVideoDemo() {
      const isToday = moment(this.filterValue.selectedDate).isSame(moment(), 'day')
      const isYesterday = moment(this.filterValue.selectedDate).isSame(
        moment().subtract(1, 'days'),
        'day'
      )
      const isTodayOrYesterday = isToday || isYesterday
      if (!isTodayOrYesterday) {
        return this.$mcToast.error(
          this.$t('videoHistory.widgetDownload.toastError.noVideoInRanges')
        )
      }

      const _startTime = this.filterValue.selectedDate + `T${this.filterValue.startTime}:00`
      const _endTime = this.filterValue.selectedDate + `T${this.filterValue.endTime}:00`
      if (this.getDurationBetween2Dates(_startTime, _endTime) < 0) {
        return this.$mcToast.error(this.$t('videoHistory.widgetDownload.toastError.timesIsInvalid'))
      }

      const channel =
        this.deviceType === 'bsj'
          ? parseInt(this.filterValue.channel.value.slice(2))
          : this.filterValue.channel.value // 1, 2, 3 etc

      const videoDemo =
        this.dataDemoVideoHistory[this.$route.params.vehicleId.toString()][channel - 1]

      const fileDownloaded = []
      videoDemo.forEach((video) => {
        const arr = video.split('.')[0].split('_')
        const hour = parseInt(arr[arr.length - 3])
        const minute = parseInt(arr[arr.length - 2])
        const second = parseInt(arr[arr.length - 1])
        const _dataVideo =
          this.filterValue.selectedDate +
          'T' +
          `${this.addLeadingZero(hour)}:${this.addLeadingZero(minute)}:${this.addLeadingZero(
            second
          )}`
        if (this.isBetweenDate(_dataVideo, _startTime, _endTime)) {
          fileDownloaded.push(video)
        }
      })

      if (!fileDownloaded.length)
        return this.$mcToast.error(
          this.$t('videoHistory.widgetDownload.toastError.noVideoInRanges')
        )

      this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', true)
      await this.delay(1000)
      this.$refs['download-history'].hide()
      this.$mcToast.success(this.$t('videoHistory.processingDownloadVideo'))

      const videos = fileDownloaded.map((filename, index) => {
        const arr = filename.split('.')[0].split('_')
        const hour = parseInt(arr[arr.length - 3])
        const minute = parseInt(arr[arr.length - 2])
        const second = parseInt(arr[arr.length - 1])
        const _startTimeVideo =
          this.filterValue.selectedDate +
          'T' +
          `${this.addLeadingZero(hour)}:${this.addLeadingZero(minute)}:${this.addLeadingZero(
            second
          )}`
        return {
          channel,
          downloadId: index,
          downloadOn: this.now(),
          endTime: this.momentAdd(_startTimeVideo, 1, 'minute').format('YYYY-MM-DDTHH:mm:ss'),
          mediaFilename: filename,
          startTime: _startTimeVideo,
          url: null,
          users: {
            fullname: this.$store.state.identity.whoami.name,
          },
          vehicle: {
            hullNo: null,
            id: this.$route.params.vehicleId,
            licensePlate: this.$store.state.vehicle.vehicleDetail.licensePlate,
            vehicleType: {
              category: this.$store.state.vehicle.vehicleDetail.vehicleCategory,
              type: this.$store.state.vehicle.vehicleDetail.vehicleType,
            },
          },
          status: 'I',
        }
      })

      const promisesGetSignedUrl = []

      for (let i = 0; i < videos.length; i++) {
        promisesGetSignedUrl.push(
          this.$store.dispatch('vehicle/getSignedUrlVideoDemo', videos[i].mediaFilename)
        )
      }

      Promise.all(promisesGetSignedUrl).then(async (response) => {
        response.forEach((url, index) => {
          videos[index].url = url
        })
        this.$store.commit('vehicle/updateDownloadVideoHistoriesWidgetData', [
          ...this.$store.state.vehicle.downloadVideoHistoriesWidgetData,
          ...videos,
        ])
        document.body.classList.add('mc-widget-download')
        await this.delay(5000)
        this.$store.commit(
          'vehicle/updateDownloadVideoHistoriesWidgetData',
          this.$store.state.vehicle.downloadVideoHistoriesWidgetData.filter(
            (data) => !videos.some((video) => video.startTime === data.startTime)
          )
        )
        this.$store.commit('vehicle/updateDownloadVideoHistoriesSuccessData', [
          ...this.$store.state.vehicle.downloadVideoHistoriesSuccessData,
          ...videos.map((video) => ({
            ...video,
            status: 'S',
          })),
        ])
      })

      return
    },
    uploadVideoToS3() {
      if (this.isVideoDemo) {
        this.handleDownloadVideoDemo()
        return
      }
      const isBsj = this.deviceType === 'bsj'
      const isJc = this.deviceType === 'jc'
      let variables = {
        input: {
          imei: this.vehicleDetail.imei,
        },
      }

      const _startTime = this.filterValue.selectedDate + `T${this.filterValue.startTime}:00`
      const _endTime = this.filterValue.selectedDate + `T${this.filterValue.endTime}:00`

      let _vehicleVideos = []
      this.$store.state.vehicle.vehicleVideos.forEach((videoInHour) => {
        _vehicleVideos.push(...videoInHour.videos)
      })

      if (isBsj) {
        if (this.getDurationBetween2Dates(_startTime, _endTime) < 0) {
          return this.$mcToast.error(
            this.$t('videoHistory.widgetDownload.toastError.timesIsInvalid')
          )
        }
        if (this.getDurationBetween2Dates(_startTime, _endTime) > 5) {
          return this.$mcToast.error(
            this.$t('videoHistory.widgetDownload.toastError.maxTimesAllowed')
          )
        }

        const videoBetweenRangesDate = _vehicleVideos.filter((video) => {
          return (
            this.isBetweenDate(video.startTime, _startTime, _endTime) ||
            this.isBetweenDate(video.endTime, _startTime, _endTime) ||
            (video.startTime === _startTime && video.endTime === _endTime)
          )
        })

        if (videoBetweenRangesDate.length === 0) {
          return this.$mcToast.error(
            this.$t('videoHistory.widgetDownload.toastError.noVideoInRanges')
          )
        }

        variables.input['bsjInput'] = {
          channel: this.filterValue.channel.value,
          startTime: this.formatDateToUtc(_startTime),
          endTime: this.formatDateToUtc(_endTime),
        }
      } else if (isJc) {
        _vehicleVideos = _vehicleVideos.map((video, i) => {
          return {
            ...video,
            endTime: moment(_vehicleVideos[i].startTime)
              .add(1, 'minute')
              .format('YYYY-MM-DDTHH:mm:ss'),
          }
        })
        let videoBetweenRangesDate = _vehicleVideos.filter((video) => {
          return (
            this.isBetweenDate(video.startTime, _startTime, _endTime) ||
            this.isBetweenDate(video.endTime, _startTime, _endTime)
          )
        })
        if (
          videoBetweenRangesDate.length &&
          videoBetweenRangesDate.every((video) => video.isDownloaded)
        ) {
          return this.$mcToast.error(
            this.$t('videoHistory.widgetDownload.toastError.videoHasBeenDownloaded')
          )
        }
        videoBetweenRangesDate = videoBetweenRangesDate.filter((video) => !video.isDownloaded)
        if (videoBetweenRangesDate.length === 0) {
          return this.$mcToast.error(
            this.$t('videoHistory.widgetDownload.toastError.noVideoInRanges')
          )
        }
        if (videoBetweenRangesDate.length > 5) {
          return this.$mcToast.error(
            this.$t('videoHistory.widgetDownload.toastError.downloadMaxAllowed')
          )
        }

        variables.input['jcInput'] = {
          cameraPosition: this.filterValue.channel.value,
          filename: videoBetweenRangesDate
            .filter((video) => !video.isDownloaded)
            .map((video) => video.mediaFilename),
        }
      }
      this.track('Download Video History')
      this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', true)
      this.$store.dispatch('vehicle/requestSetUploadMedia', variables).then((errorResponse) => {
        if (errorResponse) {
          this.$mcToast.error(errorResponse)
          this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
        } else {
          const _variables = variables
          if (isJc) {
            _variables.input.jcInput['startTime'] = this.formatDateToUtc(_startTime)
            _variables.input.jcInput['endTime'] = this.formatDateToUtc(_endTime)
          }
          this.$store.commit('vehicle/updateDownloadVideoHistoriesLastDownload', {
            ..._variables,
            vehicleId: this.$store.state.vehicle.vehicleId,
          })
          setTimeout(() => {
            this.donwloadProg()
          }, 3000)
        }
      })
    },
    handleClickDownload() {
      if (
        !this.filterValue.channel ||
        !this.filterValue.selectedDate ||
        !this.filterValue.startTime ||
        !this.filterValue.endTime
      ) {
        return this.$mcToast.error(
          this.$t('videoHistory.widgetDownload.toastError.allFieldIsRequired')
        )
      }
      this.uploadVideoToS3()
    },
    donwloadProg() {
      const variables = {
        filter: {
          allUsers: false,
          channel: ['CH01', 'CH02', 'CH03', 'CH04'],
          startDate: this.today()[0],
          endDate: this.today()[1],
          orderBy: JSON.stringify({ downloadOn: 'desc' }),
        },
      }
      this.$store.dispatch('vehicle/requestDownloadVideoHistories', variables).then((data) => {
        if (data) {
          this.$store.commit('vehicle/updateDownloadVideoHistoriesFirstData', data)
          this.$store.commit('vehicle/updateDownloadVideoHistoriesWidgetData', data)
          this.$store.commit(
            'vehicle/updateDownloadVideoHistoriesInProgressFirstData',
            data.filter((video) => video.status === 'I')
          )
          this.$refs['download-history'].hide()
          this.$mcToast.success(this.$t('videoHistory.processingDownloadVideo'))
          document.body.classList.add('mc-widget-download')
        }
      })
    },
  },
}
</script>
